import create from 'zustand';

type FilterState = {
    // The current open state
    isOpen: boolean;
    // One-shot: opens the drawer straight into this attribute's detail view, then gets cleared.
    initialAttribute: string | null;
    openDropdownCount: number;
    isDetailOpen: boolean;

    actions: {
        setIsDetailOpen: (isDetailOpen: boolean) => void;
        openDropdown: () => void;
        closeDropdown: () => void;
        setIsOpen: (isOpen: boolean) => void;
        close: () => void;
        open: () => void;
        toggle: () => void;
        openAttribute: (attribute: string) => void;
        clearInitialAttribute: () => void;
    };
    // Specify the open state
};

export const useFilterState = create<FilterState>((set, get) => ({
    isOpen: false,
    initialAttribute: null,
    openDropdownCount: 0,
    isDetailOpen: false,
    actions: {
        setIsDetailOpen: (isDetailOpen) => set({ isDetailOpen }),
        openDropdown: () => set({ openDropdownCount: get().openDropdownCount + 1 }),
        closeDropdown: () => set({ openDropdownCount: Math.max(0, get().openDropdownCount - 1) }),
        setIsOpen: (isOpen) => set({ isOpen }),
        close: () => get().actions.setIsOpen(false),
        open: () => get().actions.setIsOpen(true),
        toggle: () => {
            const {
                isOpen,
                actions: { setIsOpen },
            } = get();
            setIsOpen(!isOpen);
        },
        openAttribute: (attribute) => set({ isOpen: true, initialAttribute: attribute }),
        clearInitialAttribute: () => set({ initialAttribute: null }),
    },
}));
